import script from "./endPage.vue?vue&type=script&setup=true&lang=js"
export * from "./endPage.vue?vue&type=script&setup=true&lang=js"

import "./endPage.vue?vue&type=style&index=0&id=21086996&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21086996"]])

export default __exports__